import { Box } from '../../../../../../mads';
import { Text } from '../../../../../../mads/Text';
import { useI18n } from '../../../../../../shared/I18n';
import { useViewjobOneGraphModel } from '../../../../context/ViewJobDataContext';
import { useLocationDisplayFromContext, useTrueJobLocation, LocationDisplayType } from '../../../../utils/locationUtils';
import { JobLocation } from '../JobLocation';

import { colors } from '@indeed/ifl-tokens';
import React from 'react';

const simple = {
    color: colors.neutral[800],
    fontSize: 16,
};

const disclaimerStyle = {
    color: colors.neutral[700],
    fontSize: 14,
    marginTop: 4,
};

export function LocationSection() {
    const viewjobOneGraphModel = useViewjobOneGraphModel();
    const { gettext } = useI18n();
    const trueJobLocation = useTrueJobLocation();
    const display = useLocationDisplayFromContext();

    if (!viewjobOneGraphModel) {
        return null;
    }

    const { remoteWorkModel, tags } = viewjobOneGraphModel.job;
    const { isSimpleVjImproveActive } = viewjobOneGraphModel.features;
    const showMLADisclaimer = !!trueJobLocation;

    const style = {
        marginBottom: 0,
        ...(isSimpleVjImproveActive && simple),
        ...(Boolean(tags) && { marginBottom: 8 }),
    };

    const disclaimer = showMLADisclaimer ? (
        <Text sx={disclaimerStyle}>
            {gettext('Actively hiring candidates from your area')}
        </Text>
    ) : null;

    if (display.type === LocationDisplayType.LOCATION_WITH_REMOTE) {
        return (
            <Box>
                <Box sx={{ ...style, flexDirection: 'row' }}>
                    <Text>{display.resolvedLocation}</Text>
                    <Box sx={{ paddingLeft: 8, paddingRight: 8 }}>
                        <Text>•</Text>
                    </Box>
                    <Text>{remoteWorkModel?.text}</Text>
                </Box>
                {disclaimer}
            </Box>
        );
    }

    if (display.type === LocationDisplayType.STREET_ADDRESS) {
        return <JobLocation />;
    }

    if (display.type === LocationDisplayType.LOCATION_ONLY) {
        return (
            <Box sx={style}>
                <Text level={3} sx={{ color: colors.neutral['1000'] }}>
                    {display.resolvedLocation}
                </Text>
                {disclaimer}
            </Box>
        );
    }

    if (display.type === LocationDisplayType.REMOTE_ONLY) {
        return (
            <Box sx={style}>
                <Text>{remoteWorkModel?.text}</Text>
                {disclaimer}
            </Box>
        );
    }

    return null;
}
